import { render, staticRenderFns } from "./DistributorsTotalsTable.vue?vue&type=template&id=cb64a2e2&"
import script from "./DistributorsTotalsTable.vue?vue&type=script&lang=js&"
export * from "./DistributorsTotalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports